import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default class extends Controller {
  static values = {
    enableTime: Boolean,
    maxDate: String,
    minDate: String
  }

  connect() {
    const enableTime = this.enableTimeValue
    const isRussian = document.documentElement.lang.startsWith("ru")
    const options = {
      altInput: true,
      altFormat: isRussian
        ? (enableTime ? "d.m.Y — H:i" : "d.m.Y")
        : (enableTime ? "d M Y — H:i" : "d M Y"),
      allowInput: true,
      dateFormat: enableTime ? "Y-m-d H:i" : "Y-m-d",
      disableMobile: true,
      enableTime,
      closeOnSelect: !enableTime,
      time_24hr: true
    }

    if (isRussian) {
      options.locale = Russian
    }

    if (this.hasMaxDateValue) {
      options.maxDate = this.maxDateValue
    }

    if (this.hasMinDateValue) {
      options.minDate = this.minDateValue
    }

    this.instance = flatpickr(this.element, options)
  }

  disconnect() {
    this.instance?.destroy()
  }
}
